import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import SummaryLabelValue from '../../../summaryLabel/SummaryLabelValue';
import Translation from '../../../../../../../../common/components/translation/Translation';

export interface ISummaryFinanceTermRateProps {
  term: number;
  dataTest: string;
}

const SummaryFinanceTermRate: FC<ISummaryFinanceTermRateProps> = ({ term, dataTest }) => {
  const styles = summaryLabelStyles();

  return (
    <Grid container={true} justifyContent={'space-between'} spacing={3} className={styles.lineContainer}>
      <SummaryLabelTitle
        label={<Translation id={'trans__configurator__customise_page_finance_details__summary_term_label'} />}
        colSm={8}
        colXs={6}
      />
      <SummaryLabelValue
        text={
          <Translation
            id={'trans__configurator__customise_page_finance_details__summary_term_value_label'}
            values={{ duration: +term, value: +term }}
          />
        }
        dataTest={dataTest}
        colSm={4}
        colXs={6}
      />
    </Grid>
  );
};

export default SummaryFinanceTermRate;
